import { render, staticRenderFns } from "./AccountFormDialog.vue?vue&type=template&id=20c83390&scoped=true&"
import script from "./AccountFormDialog.vue?vue&type=script&lang=js&"
export * from "./AccountFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountFormDialog.vue?vue&type=style&index=0&id=20c83390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c83390",
  null
  
)

export default component.exports